// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wGN_","top":"styles_top__1J57E","left":"styles_left__3O3eD","description":"styles_description__36_Ae"};